import { Button, Table, Tag } from 'antd';
import moment from 'moment';
import React from 'react';
import { useTranslation } from 'react-i18next';
import colorsDark from '../../../../assets/colors/dark';

const DeviceActivationTable = ({
  devices,
  rowSelection,
  handleTableChange,
  isLoadActiveLicense,
  license,
  onDeactivateDevice,
  singleActiveDevice,
  syncLoading,
  syncActivateDevice,
  activateChain,
}) => {
  const { t } = useTranslation();

  const dataSource = React.useMemo(() => {
    return (
      devices?.data?.map((device) => ({
        ...device,
        key: device.serial,
      })) ?? []
    );
  }, [devices?.data]);

  return (
    <Table
      rowClassName={(record) => !record.enabled && 'disabled-row'}
      rowSelection={rowSelection}
      dataSource={dataSource}
      pagination={devices && devices.pagination}
      loading={devices && devices.loading}
      onChange={handleTableChange}
      columns={[
        {
          title: t('Name'),
          dataIndex: 'name',
          key: 'name_device',
          sorter: (a, b) => a.name.localeCompare(b.name),
        },
        {
          title: t('State'),
          key: 'log_action',
          width: 130,
          sorter: (a, b) => {
            const dataA = isLoadActiveLicense.some(
              (serial) => serial === a.serial
            )
              ? 'Activating'
              : a.service
                ? 'Activated'
                : 'Not activated';
            const dataB = isLoadActiveLicense.some(
              (serial) => serial === b.serial
            )
              ? 'Activating'
              : b.service
                ? 'Activated'
                : 'Not activated';
            return dataA.localeCompare(dataB);
          },
          render: (device) =>
            isLoadActiveLicense.some((serial) => serial === device.serial) ? (
              <Tag
                style={{ width: 120, textAlign: 'center' }}
                color={colorsDark.$warning}
              >
                {t('Activating')}
              </Tag>
            ) : device.service ? (
              <Tag
                style={{ width: 120, textAlign: 'center' }}
                color={colorsDark.$online}
              >
                {t('Activated')}
              </Tag>
            ) : (
              <Tag
                style={{ width: 120, textAlign: 'center' }}
                color={colorsDark.$offline}
              >
                {t('Not activated')}
              </Tag>
            ),
        },
        {
          title: t('Active date'),
          key: 'log_activatedAt',
          dataIndex: 'service',
          sorter: (a, b) =>
            a.service?.activatedAt?.localeCompare(b.service?.activatedAt),
          render: (service) =>
            service?.activatedAt
              ? moment(service.activatedAt).format('DD-MM-YYYY')
              : '',
        },
        {
          title: t('License Code'),
          key: 'service_license_code_device',
          dataIndex: 'service',
          render: (service) =>
            service?.licenseCode ? service?.licenseCode : '',
        },
        {
          title: t('License Info'),
          key: 'service_license_info_device',
          dataIndex: 'service',
          render: (service) =>
            service?.licenseInfo ? service?.licenseInfo : '',
        },
        {
          title: t('Action'),
          key: 'actions',
          width: 130,
          render: (device) =>
            device.service ? (
              <div
                className="edit-button"
                onClick={() => onDeactivateDevice(device.name, device.serial)}
              >
                <Button danger htmlType="submit">
                  {t('Deactivate')}
                </Button>
              </div>
            ) : (
              <div
                className="edit-button"
                onClick={() => singleActiveDevice(device.serial)}
              >
                <Button
                  loading={isLoadActiveLicense.some(
                    (serial) => serial === device.serial
                  )}
                  disabled={!license}
                  htmlType="submit"
                >
                  {t('Activate')}
                </Button>
              </div>
            ),
        },
      ]}
      footer={() => (
        <div className="sync-activates">
          <Button
            loading={syncLoading}
            onClick={() => syncActivateDevice()}
            type="primary"
            disabled={
              !license ||
              activateChain.length === 0 ||
              isLoadActiveLicense.length > 0 ||
              activateChain.length > license.size - license.numberActive
            }
          >
            {t('Sync activates')} ({activateChain.length})
          </Button>
        </div>
      )}
    />
  );
};

export default DeviceActivationTable;
